import React from 'react';
import {
    Create, Edit, List,
    Datagrid, EditButton, TextField, TabbedForm, FormTab, TextInput, required, ReferenceInput, SelectInput, NumberInput, Filter, ReferenceField
} from 'react-admin';
import { Actions } from '../common/actions.js'

const TemplateFilters = ({ showId, ...props }) => (
    <Filter {...props}>
        {showId && <NumberInput label="Id" source="id" alwaysOn allowEmpty />}
        <ReferenceInput source="alarmTypeId" alwaysOn allowEmpty reference="misc/getalarmtypes"><SelectInput optionText="name" /></ReferenceInput>
    </Filter>
);

export const TemplateList = props => (
    <List {...props} actions={<Actions />} filterDefaultValues={{ development: false }} filters={<TemplateFilters showId={true} />} title="Alarm templates" exporter={false} bulkActionButtons={false}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" />
            <ReferenceField source="alarmTypeId" reference="misc/getalarmtypes" linkType={false}><TextField source="name" /></ReferenceField>
            <TextField source="subjectTemplate"/>
            <TextField source="bodyTemplate"/>
            <EditButton />
        </Datagrid>
    </List>
);

const AlarmTemplateForm = (props) => (
    <TabbedForm {...props} defaultValue={{ entreDataSource: 1 }} className="width-100em-sub-div">
        <FormTab label="general">
            {<TextInput source="name" reference="name" validate={required()} />}
            <ReferenceInput source="alarmTypeId" validate={required()} reference="misc/getalarmtypes"><SelectInput optionText="name" /></ReferenceInput>
            {<TextInput multiline source="subjectTemplate" reference="subjectTemplate" />}
            {<TextInput multiline source="bodyTemplate" validate={required()} reference="bodyTemplate" />}
        </FormTab>
    </TabbedForm>
);

export const TemplateEdit = props => (
    <Edit title="Edit template" {...props}>
        <AlarmTemplateForm permissions={props.permissions} isEditing={true} />
    </Edit>
);

export const TemplateCreate = props => (
    <Create title="Create template" {...props}>
        <AlarmTemplateForm permissions={props.permissions} />
    </Create>
);